import { BASE_URL_STATION } from "../services/stationsAPI";
import { useParams } from "react-router-dom";
import {
  OrderByType,
  useGenericAPI,
  useSingleGenericAPI,
} from "../../../utils/genericAPI/useGenericAPI";
import { ChargePoint, ChargePointPatch } from "../types/stations.types";
import useQueryURL from "../../../common/hooks/useQueryURL";


export interface UseChargePointConfig {
  pageSize?: number;
  orderBy?: OrderByType<ChargePoint>;
  stationId?: string;
}

/**
 * useChargePoint 
 *
 * @param config 
 * @returns 
 */
export default function useChargePoint(config: UseChargePointConfig) {
  const { stationId } = useParams();
  const stationIdFound = config.stationId || stationId;

  if (!stationIdFound) {
    console.error("No stationId found");
  }

  const baseURLChargePoint = BASE_URL_STATION + "/" + stationIdFound + "/chargepoints";

  const { getAllQuery, createNew } = useGenericAPI<
    ChargePoint,
    ChargePointPatch,
    ChargePointPatch
  >({
    baseURL: baseURLChargePoint,
    APIname: "chargepoints-"+ stationIdFound,
    pageSize: config.pageSize,
    orderBy: config.orderBy || "-charge_point_created_at",
    disableGet: !stationIdFound,
    onSucessRefetchRessources:['chargepoints', 'hardwares']
  });
  return {
    stationIdFound,
    getAllBorneQuery: getAllQuery,
    createNewBorneQuery: createNew,
  };
}

export interface UseSingleChargePointConfig {
  chargePointId?: string;
  stationId?: string;
}

/**
 * useSingleBorne 
 *
 * @param config 
 * @returns 
 */
export function useSingleChargePoint(config: UseSingleChargePointConfig) {
  const { stationId, chargePointId} = useParams();
  const {getQueryValue} = useQueryURL();
  const chargePointIdURL = getQueryValue("chargePointId");
  const stationIdFound = config.stationId || stationId;
  const chargePointIdFound = config.chargePointId || chargePointId || chargePointIdURL;
  if (!stationIdFound) {
    console.error("No stationId found");
  }

  if (!chargePointIdFound) {
    console.error("No chargePointId found");
  }

  const baseURLchargepoint = BASE_URL_STATION + "/" + stationIdFound + "/chargepoints";

  const { singleQuery, deleteQuery, updateQuery } = useSingleGenericAPI<
    ChargePoint,
    ChargePointPatch
  >({
    baseURL: baseURLchargepoint,
    APIname: "chargepoints-"+ stationIdFound,
    id: chargePointIdFound || "",
    disableGet: !stationIdFound || !chargePointIdFound,
    onSucessRefetchRessources:['chargepoints', 'hardwares']
  });

  return {
    stationIdFound,
    chargePointIdFound,
    singleChargePointQuery: singleQuery,
    deleteChargePointQuery: deleteQuery,
    updateChargePointQuery: updateQuery,
  };
}
